<template>
  <div class="tp-wrap">
    <div class="tp-label">Preview do template</div>
    <div class="tp-phone">
      <div class="tp-phone-header">
        <div class="tp-avatar"></div>
        <div class="tp-name-bar"></div>
        <div class="tp-icons">
          <svg width="14" height="14" fill="none" stroke="rgba(255,255,255,.5)" stroke-width="2" viewBox="0 0 24 24"><path d="M15 10l5 5-5 5"/></svg>
        </div>
      </div>
      <div class="tp-phone-body">
        <div class="tp-bubble">
          <!-- Header Image -->
          <div v-if="headerType === 'IMAGE'" class="tp-header-media">
            <img v-if="headerImageUrl" :src="headerImageUrl" alt="header">
            <div v-else class="tp-media-placeholder">
              <svg width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-5-5L5 21"/></svg>
            </div>
          </div>
          <!-- Header QRCode dinâmico do participante (preview com sample) -->
          <div v-if="headerType === 'QRCODE_PARTICIPANT'" class="tp-header-media tp-header-qr">
            <img :src="qrSampleUrl" alt="QR Code do participante">
          </div>
          <!-- Header Video -->
          <div v-if="headerType === 'VIDEO'" class="tp-header-media">
            <video v-if="headerVideoUrl" :src="headerVideoUrl" style="width:100%;display:block;" preload="metadata"></video>
            <div v-else class="tp-media-placeholder">
              <svg width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>
              <span>Vídeo</span>
            </div>
          </div>
          <!-- Header Document -->
          <div v-if="headerType === 'DOCUMENT'" class="tp-header-doc">
            <svg width="16" height="16" fill="none" stroke="#EF4444" stroke-width="2" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
            <span>{{ headerDocumentName || 'documento.pdf' }}</span>
          </div>
          <!-- Header Location -->
          <div v-if="headerType === 'LOCATION'" class="tp-header-location">
            <svg width="14" height="14" fill="none" stroke="#556ee6" stroke-width="2" viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
            <span>Localização</span>
          </div>
          <!-- Header Text -->
          <div v-if="headerType === 'TEXT' && headerText" class="tp-header-text">{{ renderText(headerText) }}</div>

          <!-- Body -->
          <div class="tp-content">
            <div v-if="bodyText" class="tp-body-text" v-html="formatBody(bodyText)"></div>
            <div v-else class="tp-body-empty">O texto da mensagem aparecerá aqui...</div>

            <!-- Footer -->
            <div v-if="footerText" class="tp-footer-text">{{ footerText }}</div>

            <!-- Timestamp -->
            <div class="tp-time">{{ currentTime }} <span class="tp-checks">✓✓</span></div>
          </div>
        </div>

        <!-- Buttons (fora do bubble) -->
        <div v-if="buttons && buttons.length" class="tp-buttons">
          <div v-for="(btn, i) in buttons" :key="i" class="tp-btn">
            <svg v-if="btn.type === 'URL'" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
            <svg v-else-if="btn.type === 'PHONE_NUMBER'" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
            <svg v-else width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
            {{ btn.text || 'Botão' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TemplatePreview',
  props: {
    headerType: { type: String, default: '' },
    headerText: { type: String, default: '' },
    headerImageUrl: { type: String, default: '' },
    headerVideoUrl: { type: String, default: '' },
    headerDocumentName: { type: String, default: '' },
    bodyText: { type: String, default: '' },
    footerText: { type: String, default: '' },
    buttons: { type: Array, default: () => [] },
    examples: { type: Object, default: () => ({}) }
  },
  computed: {
    currentTime () {
      const now = new Date()
      return `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`
    },
    /**
     * URL pública do QR sample no S3 (DigitalOcean Spaces).
     * É o mesmo arquivo que vai ser enviado pra Meta como sample do template.
     * No envio real, é substituído pelo QR único do participante.
     */
    qrSampleUrl () {
      return 'https://xcode-eventfy.sfo3.digitaloceanspaces.com/rsvpfy/qrcode.png'
    }
  },
  methods: {
    renderText (text) {
      if (!text) return ''
      let result = text
      Object.keys(this.examples).forEach(key => {
        if (this.examples[key]) {
          result = result.replace(`{{${key}}}`, this.examples[key])
        }
      })
      return result
    },
    formatBody (text) {
      if (!text) return ''
      let result = this.renderText(text)
      result = result.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      result = result.replace(/\*(.*?)\*/g, '<strong>$1</strong>')
      result = result.replace(/_(.*?)_/g, '<em>$1</em>')
      result = result.replace(/~(.*?)~/g, '<del>$1</del>')
      result = result.replace(/\{\{(\d+)\}\}/g, '<span class="tp-var">{{$1}}</span>')
      result = result.replace(/\r?\n/g, '<br>')
      return result
    }
  }
}
</script>

<style scoped>
.tp-wrap {
  position: sticky;
  top: 0;
  padding: 20px;
}

.tp-label {
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #7A8BA7;
  margin-bottom: 12px;
  text-align: center;
}

.tp-phone {
  background: #ECE5DD;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid #E3E8F0;
  box-shadow: 0 4px 16px rgba(27,42,74,.08);
}

.tp-phone-header {
  background: #075E54;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.tp-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255,255,255,.2);
  flex-shrink: 0;
}

.tp-name-bar {
  height: 8px;
  width: 80px;
  background: rgba(255,255,255,.4);
  border-radius: 4px;
}

.tp-icons { margin-left: auto; }

.tp-phone-body {
  padding: 12px 8px;
  min-height: 240px;
}

.tp-bubble {
  background: #FFF;
  border-radius: 0 8px 8px 8px;
  max-width: 92%;
  box-shadow: 0 1px 1px rgba(0,0,0,.06);
  overflow: hidden;
}

/* Header media */
.tp-header-media {
  width: 100%;
  background: #F0F2F6;
}

.tp-header-media img {
  width: 100%;
  display: block;
}

.tp-media-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: #C4CFDE;
  padding: 30px;
  min-height: 100px;
}

.tp-media-placeholder span {
  font-size: 10px;
  font-weight: 600;
}

/* Header QR — preview com fundo branco pra realçar o QR */
.tp-header-qr {
  background: #FFF;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tp-header-qr img {
  width: auto;
  max-width: 70%;
  max-height: 160px;
  display: block;
  image-rendering: pixelated;
}

/* Header document */
.tp-header-doc {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 12px;
  background: #F0F2F6;
  font-size: 11px;
  color: #3D4F6F;
  font-weight: 500;
}

/* Header location */
.tp-header-location {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 12px;
  background: rgba(85,110,230,.08);
  font-size: 11px;
  color: #556ee6;
  font-weight: 600;
}

/* Header text */
.tp-header-text {
  padding: 10px 12px 2px;
  font-size: 13px;
  font-weight: 700;
  color: #1B2A4A;
}

/* Content area */
.tp-content {
  padding: 6px 12px 8px;
}

.tp-body-text {
  font-size: 12px;
  color: #3D4F6F;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}

.tp-body-empty {
  font-size: 12px;
  color: #C4CFDE;
  font-style: italic;
  padding: 10px 0;
}

.tp-body-text :deep(.tp-var) {
  background: rgba(74,108,247,.12);
  color: #4A6CF7;
  padding: 1px 5px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: 600;
}

.tp-body-text :deep(strong) {
  font-weight: 700;
  color: #1B2A4A;
}

.tp-body-text :deep(em) {
  font-style: italic;
}

.tp-body-text :deep(del) {
  text-decoration: line-through;
}

.tp-footer-text {
  font-size: 10.5px;
  color: #7A8BA7;
  margin-top: 6px;
  padding-top: 4px;
}

.tp-time {
  font-size: 9.5px;
  color: #C4CFDE;
  text-align: right;
  margin-top: 4px;
}

.tp-checks { font-size: 8px; }

/* Buttons */
.tp-buttons {
  margin-top: 4px;
  max-width: 92%;
}

.tp-btn {
  padding: 7px 8px;
  text-align: center;
  color: #0EA5E9;
  font-size: 11.5px;
  font-weight: 600;
  background: #FFF;
  border-radius: 8px;
  margin-top: 3px;
  box-shadow: 0 1px 1px rgba(0,0,0,.06);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
</style>
